import React, { useState } from 'react'
import { ArrowBackIcon } from '@chakra-ui/icons'
import {
  Box,
  Image,
  Stack,
  Text,
  useMediaQuery,
  VStack,
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import LogoutHeader from '../../components/LogoutHeader'
const quilmesImages = require.context('../../assets/images', true)

function AttributesManagement() {
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const { userRegister } = useAuth()

  return (
    <Stack paddingBottom={'2rem'}>
      <Box
        alignItems={'center'}
        className='logo-home'
        display={'flex'}
        justifyContent={'space-around'}
      >
        <LogoutHeader />
      </Box>
      <Stack borderBottom={' 1px solid #E1E1E1'}>
        <Box
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'space-between'}
          margin={'0 auto'}
          padding={{ base: '1rem 1rem', md: '1rem 5rem' }}
          width={{ base: '90%', md: '100%' }}
        >
          <Link to={'/home'}>
            <ArrowBackIcon color={'#0A0808'} h={6} w={6} />
          </Link>
          <Text fontWeight={'bold'} paddingLeft={{ base: '0rem', md: '7rem' }}>
            Gestión de Atributos de producto
          </Text>
          <Box></Box>
        </Box>
      </Stack>
      <VStack mx={'auto'} paddingTop={'20px'}>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/brand-management'>
            <Text className='texto-gestion'> Marca </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/volume-management'>
            <Text className='texto-gestion'> Volumen </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/material-management'>
            <Text className='texto-gestion'> Material </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/battlefield-management'>
            <Text className='texto-gestion'> Battlefield </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
      </VStack>
    </Stack>
  )
}

export default AttributesManagement
